module.exports = __webpack_public_path__ + "img/shoucang_normal.7c7bd43d.png";